import { memo } from "react";
import { Checkbox } from "@/shared/ui/components/custom";
import type { ItemDetails } from "@/app/types/items.types";
import checkCircleGreen from "@/assets/svgs/checkCircleGreen.svg";

interface ItemsListProps {
  items: ItemDetails[];
  savedItems: ItemDetails[];
  selectedItems: number[];
  handleSelectItem: (index: number, checked: boolean) => void;
}

export const ItemsList = memo(function ItemsList({
  items,
  savedItems,
  selectedItems,
  handleSelectItem,
}: ItemsListProps) {
  return (
    <>
      {items.map((item, index) => {
        const savedItem = savedItems.find(
          (savedItem) => savedItem.name_en === item.name_en
        );
        const isSaved = !!savedItem;
        const details: string[] = [];

        // Check if the saved item has all required fields filled
        const itemHasAllFields =
          savedItem &&
          savedItem.base_u_o_m_id &&
          savedItem.purchase_u_o_m_id &&
          savedItem.pack_size !== undefined &&
          savedItem.per_level !== undefined;

        if (isSaved && savedItem) {
          if (savedItem.base_u_o_m_label) details.push(savedItem.base_u_o_m_label);
          if (savedItem.purchase_u_o_m_label)
            details.push(savedItem.purchase_u_o_m_label);
          if (savedItem.pack_size) {
            const unit = savedItem.base_u_o_m_label;
            details.push(`${savedItem.pack_size}${unit}`);
          }
          if (savedItem.per_level) {
            const unit = savedItem.base_u_o_m_label;
            details.push(`min ${savedItem.per_level}${unit}`);
          }
          if (savedItem.tag_ids && savedItem.tag_ids.length > 0) {
            details.push(
              `${savedItem.tag_ids.length} tag${
                savedItem.tag_ids.length > 1 ? "s" : ""
              }`
            );
          }
        }

        return (
          <div
            key={index}
            className={`flex items-center justify-between p-4 border-b border-grey-100 ps-8 hover:bg-green-50 ${
              selectedItems.includes(index) ? "bg-green-50" : ""
            }`}
          >
            <div className="flex items-center gap-2 flex-1">
              <Checkbox
                checked={selectedItems.includes(index)}
                onCheckedChange={(checked) =>
                  handleSelectItem(index, checked)
                }
                size="xl"
              />
              <div className="flex items-center gap-2 flex-1">
                <span
                  className={`text-xs  text-grey-900 ${
                    selectedItems.includes(index)
                      ? "font-bold"
                      : "font-medium"
                  }`}
                >
                  {item.name_en}
                </span>
              </div>
            </div>
            {isSaved && (
              <div className="flex items-center gap-2 ">
                <span className="text-sm text-grey-200 flex-shrink-0">
                  {details.join(", ")}
                </span>
                {itemHasAllFields && (
                  <img
                    src={checkCircleGreen}
                    alt="checkCircleGreen"
                    className="w-5 h-5 flex-shrink-0"
                  />
                )}
              </div>
            )}
          </div>
        );
      })}
    </>
  );
});
